module.exports = __webpack_public_path__ + "img/close.0d26c81c.svg";